import { render } from "./activitesTickets.vue?vue&type=template&id=1ef2460e"
import script from "./activitesTickets.vue?vue&type=script&lang=ts"
export * from "./activitesTickets.vue?vue&type=script&lang=ts"
script.render = render

export default script